// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavTopBarPageTitle-base__L0tMj{position:relative;display:flex;flex-shrink:0;align-items:center}.NavTopBarPageTitle-dropdownTrigger__cDjKK{top:calc(var(--size-full) - var(--size-1_5));left:var(--size-0)}@media only screen and (min-width: 64rem){.NavTopBarPageTitle-list__X57XM{width:calc(var(--size-44) - var(--size-1))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavTopBarPageTitle-base__L0tMj",
	"dropdownTrigger": "NavTopBarPageTitle-dropdownTrigger__cDjKK",
	"list": "NavTopBarPageTitle-list__X57XM"
};
export default ___CSS_LOADER_EXPORT___;
